// THE GENERATORS THE CLIENT STILL RUNS AT LOAD — and as of phase 3 there are
// none.
//
// This table is empty, and its emptiness is the point of the whole exercise.
// A surface leaves this file the day it starts shipping as a baked asset, and
// that departure is what makes the claim true rather than merely intended:
// with every generator unreferenced from any module the browser bundle
// reaches, a baked sheet is not the PREFERRED source of a material's texels,
// it is the only one that exists in the client at all.
//
//   phase 1 — stucco left, baked at 2048².
//   phase 3 — the other sixteen followed, plus the city's facade sheet and
//             the playa crust, both of which had been forging themselves in
//             render/city.ts and render/textures.ts.
//
// The file stays, and stays exported, for two reasons. It is the seam the
// pipeline is built around — `surface()` still asks it for a generator and
// still throws by name if a catalog entry claims to be forged and is not —
// and it is where a surface would come BACK to if one ever had to be
// generated per-player or per-district. Neither is speculative: render/
// attire.ts already forges per-character garment sheets through the same
// `bake()`, and it does it without this table because those sheets are not
// catalogued materials.
//
// catalog.test.ts asserts this table and SURFACE_CATALOG agree, so a surface
// that is neither shipped nor forged — or is somehow both — fails the gate
// instead of failing a frame.

import type { BakedSurface } from "./bake";

export type RuntimeGenerator = (...args: number[]) => BakedSurface;

export const RUNTIME_GENERATORS: Record<string, RuntimeGenerator> = {};
